import Styled from './styled'
import { Tabs } from 'antd'
import { useTranslate } from 'hooks/translate'

//Components
import Page from 'components/Page'
import RiskMatrix from './components/RiskMatrix'
import ActionPlan from './components/ActionPlan'
import OperationalLossAndAppetite from './components/OperationalLossAndAppetite'
const { TabPane } = Tabs
export default function PageMonthlyDashboard () {
  const { t } = useTranslate()

  return (
    <Styled
      className='page page-monthly-dashboard'
      // style={{ minWidth: '1000px', backgroundColor: '#f2f3f7' }}
    >
      <Page title={t('Summary Dashboard')} showSearch={false}>
        <Tabs
          defaultActiveKey='operationalLossAndAppetite'
          style={{ minWidth: '1000px', backgroundColor: '#f2f3f7' }}
        >
          <TabPane tab={t('Operational loss and appetite')} key='operationalLossAndAppetite'>
            {/* <div style={{ minWidth: '1000px' }}> */}
            <OperationalLossAndAppetite></OperationalLossAndAppetite>
            {/* </div> */}
          </TabPane>

          <TabPane tab={t('Action Plan')} key='actionPlan'>
            <ActionPlan></ActionPlan>
          </TabPane>

          <TabPane tab={t('Risk Matrix')} key='riskMatrix'>
            <RiskMatrix></RiskMatrix>
          </TabPane>
        </Tabs>
      </Page>
    </Styled>
  )
}
